var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M16 8.75c1.77 0 3.355.61 4.605 1.8l3.425-3.425C21.95 5.19 19.235 4 16 4c-4.69 0-8.745 2.69-10.72 6.61l3.99 3.095c.945-2.845 3.6-4.955 6.73-4.955Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M27.49 16.275c0-.785-.075-1.545-.19-2.275H16v4.51h6.47a5.578 5.578 0 0 1-2.39 3.59l3.865 3c2.255-2.09 3.545-5.18 3.545-8.825Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M9.265 18.295A7.29 7.29 0 0 1 8.885 16c0-.8.135-1.57.38-2.295l-3.99-3.095A11.957 11.957 0 0 0 4 16c0 1.94.46 3.77 1.28 5.39l3.985-3.095Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16 28c3.24 0 5.965-1.065 7.945-2.905l-3.865-3c-1.075.725-2.46 1.15-4.08 1.15-3.13 0-5.785-2.11-6.735-4.955l-3.99 3.095C7.255 25.31 11.31 28 16 28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3079b0624ce342a31f7511b21868b98b.svg";
export { ForwardRef as ReactComponent };